export default {
    infomationTip: 'Disclaimer: Content is for reference only, not investment advice. Invest with caution.',
    infomationThirdTip:
        'Disclaimer: Info from third parties, unverified by platform. For reference only, not investment advice. Invest with caution.',
    infomationStock: 'Related Stocks',
    infomationNews: 'Related News',
    informationTitle: 'News Details',
    flashNews: 'Flash news',
    newwork: 'Network timeout, please retry.',
    text01: 'Grow Your Wealth',
    text02: 'Sorry, the content does not exist.',
    downloadMsg: 'Download',
    openAppMsg: 'Open in App',
    reading: 'Read',
    readingNum: 'Read Count',
    disclaimer: 'The above information and data are sourced from third parties. This platform cannot verify their authenticity, accuracy, completeness, originality, and other aspects. The reproduced content above is for reference only and shall not constitute the position of this platform nor serve as a basis for investment decisions. Investment involves risks; proceed with caution when entering the market.',
    disclaimer4AI: 'This content is generated by this platform based on artificial intelligence analysis and integration, with data sourced from publicly available information on the Internet. While this platform makes every effort to ensure accuracy, it cannot guarantee the precision and reliability of the aforementioned content. The above content is for reference only and shall not serve as a basis for investment decisions. Investment involves risks; proceed with caution when entering the market.',
    night: 'night session',
    minutesAgo: '{n} minutes ago',
    loading: 'Loading...',
}
